import { render, staticRenderFns } from "./FornecedorUserForm.vue?vue&type=template&id=38325289"
import script from "./FornecedorUserForm.vue?vue&type=script&lang=js"
export * from "./FornecedorUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports